var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 399.43 362.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#c9d0e2;}.cls-3{fill:#e9efff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fyldning_Inspektion",
    "data-name": "Fyldning & Inspektion"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "79.8 46.07 79.8 169.07 13.3 130.68 13.3 7.68 79.8 46.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0 0 13.3 7.68 13.3 130.68 0 135 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "79.8 169.07 79.8 181.07 0 135 13.3 130.68 79.8 169.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "183.3 105.78 183.3 228.78 116.81 190.38 116.81 67.38 183.3 105.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "103.51 59.7 116.81 67.38 116.81 190.38 103.51 194.7 103.51 59.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "183.3 228.78 183.3 240.78 103.51 194.7 116.81 190.38 183.3 228.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "399.43 227.55 399.43 350.55 332.93 312.16 332.93 189.16 399.43 227.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "319.63 181.48 332.93 189.16 332.93 312.16 319.63 316.48 319.63 181.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "399.43 350.55 399.43 362.55 319.63 316.48 332.93 312.16 399.43 350.55"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindows);
export default __webpack_public_path__ + "static/media/windows.7ca3b9c7f953d8970f0352bd0a2f413c.svg";
export { ForwardRef as ReactComponent };